module.exports = __webpack_public_path__ + "static/media/math-blue.2ce8fc13.svg";